<template>
  <div class="journal-header" :class="{'sidebar-small': !showJournalSidebar}">
    <div class="header-content">
      <div class="journal-buttons">
      <div class="journal-btn-plus-wrap" v-if="thingPermission > 1">
<!--        временная кнопка 123-->
        <button @click="showMenu"
                type="button"
                :class="{ pressed: isMenuActive }"
                class="journal-btn journal-btn-plus">
          <plusIconNoBorder :fill="isMenuActive ? 'white' : 'white'" />
        </button>
        <transition name="fade">
<!--          первое меню-->
          <div v-show="isMenuActive"
               @mouseleave="hideFirstMenu"
               class="menu"
               :class="{ opened: isMenuActive }">
            <ul>
              <li class="btn-centered btn-device" @click="goToNewEvent">{{$t('index.journal.header.addNewEvent')}}</li>
              <li v-if="eventTemplates.length" class="btn-centered" @click="showSubmenu">{{$t('index.journal.header.addNewEventByTemplate')}}<chevronRightIcon /></li>
            </ul>
          </div>
        </transition>
<!--              второе меню (подменю) c шаблонами-->
        <div v-show="isSubmenuActive"
             class="submenu-wrap"
             @mouseleave="hideAllMenu"
             :class="{ opened: isSubmenuActive }">
          <div v-show="isSubmenuActive"
               :class="{ opened: isSubmenuActive }"
               class="submenu">
            <ul>
              <li v-for="(template, i) of eventTemplates"
                  :key="i" class="btn-centered btn-device"
                  @click="chooseEventTemplate(template)">
                <trim-item :string="template.name"
                           :offset="90"
                           :width="20"></trim-item>
                <button class="remove-event-template"
                        @click="eventTemplateRemove(template.id)"
                        type="button">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.3234 5.78664L11.91 13.4933C11.8967 13.7733 11.6567 14 11.3767 14H4.61668C4.33668 14 4.09668 13.7733 4.08335 13.4933L3.67002 5.78664C3.65669 5.49331 3.88336 5.23996 4.17669 5.22663C4.47003 5.2133 4.72335 5.43997 4.73669 5.7333L5.12336 12.9333H10.87L11.2567 5.7333C11.27 5.43997 11.5234 5.2133 11.8167 5.22663C12.11 5.23996 12.3367 5.49331 12.3234 5.78664ZM13.7367 3.99997C13.7367 4.2933 13.4967 4.5333 13.2034 4.5333H2.80335C2.51002 4.5333 2.27002 4.2933 2.27002 3.99997C2.27002 3.70664 2.51002 3.46664 2.80335 3.46664H5.73669V2.26664C5.73669 2.0133 5.91001 1.86664 6.16335 1.86664H9.84336C10.0967 1.86664 10.27 2.0133 10.27 2.26664V3.46664H13.2034C13.4967 3.46664 13.7367 3.70664 13.7367 3.99997ZM6.67002 3.46664H9.33669V2.79997H6.67002V3.46664ZM6.89668 12.1333C7.16335 12.1333 7.36335 11.88 7.36335 11.6266L7.23001 5.86664C7.23001 5.6133 7.01668 5.39997 6.75002 5.39997C6.49668 5.39997 6.28335 5.6133 6.29668 5.87997L6.43001 11.6533C6.43001 11.9066 6.64335 12.1333 6.89668 12.1333ZM9.09668 12.1333C9.35001 12.1333 9.56335 11.92 9.56335 11.6666L9.69668 5.90664C9.69668 5.65331 9.49669 5.42663 9.24336 5.42663C8.97669 5.42663 8.77668 5.62663 8.76335 5.87997L8.63001 11.64C8.61668 11.9066 8.83001 12.1333 9.09668 12.1333C9.08335 12.1333 9.08335 12.1333 9.09668 12.1333Z" fill="#00527F"/>
                  </svg>
                </button>
              </li>
            </ul>
          </div>
        </div>

        </div>
        <div class="journal-btn-save-wrap" v-if="thingPermission > 1">
          <button @click="saveEventTemplate"
                  type="button"
                  class="journal-btn journal-btn-save hint-cont "
                  :class="{'not-editable': !isJournalCreate}"
                  :disabled="disableSaveTemplate || !tempData.type"
          >
            <saveIconNoBorder :fill="disableSaveTemplate ? '#109cf1' : '#109cf1'"  />
            <p class="btn-hint  btn-hint_bottom">
              {{$t('index.journal.header.saveTemplate')}}
            </p>
          </button>
        </div>

      </div>
      <div v-if="!isJournalCreate" class="journal-filters" :class="{'disabled': !journalView}">
        <h2>{{$t('index.journal.header.filter')}}:</h2>
        <div class="select-cont select-cont_filter select-cont_blue-text select-cont_transparent">
          <!--        no lable here-->
          <v-select :clearable="false"
                    :searchable="true"
                    :disabled="!journalView"
                    v-model="selectDevice"
                    id="device"
                    label="name"
                    class="device-chooser"
                    :options="eventDevices"></v-select>
          <div class="placeholder">{{$t('index.journal.header.thing')}}:</div>
        </div>

        <div class="select-cont select-cont_filter select-cont_blue-text select-cont_transparent">
          <!--        no lable here-->
          <v-select :clearable="false"
                    :searchable="true"
                    :disabled="!journalView"
                    v-model="eventType"
                    id="eventType"
                    label="name"
                    @input="typeFunc()"
                    class="event-type-chooser"
                    :options="eventTypes"></v-select>
          <div class="placeholder">{{$t('index.journal.header.typeOfEvent')}}:</div>
        </div>

        <div class="select-cont select-cont_filter select-cont_blue-text select-cont_transparent">
          <!--        no lable here-->
          <datepicker :editable="false"
                      type="datetime"
                      range
                      :lang="lang"
                      @input="dateFunc()"
                      v-model="date"></datepicker>
          <div class="placeholder">{{$t('index.journal.header.time')}}:</div>
        </div>

        <form class="search-form"
              :class="{'search-from_big': bigForm}">
          <label class="search-cont">
            <search-icon></search-icon>
            <input type="text"
                   @focus="showBigForm"
                   @blur="hideBigForm"
                   @input="searchFunc()"
                   v-model="search"
                   :placeholder="$t('menu.search')">
          </label>
        </form>
      </div>
    </div>
<!--    <pre>{{eventTemplates}}</pre>-->
<!--    <pre>{{tempData}}</pre>-->
<!--    <pre>{{event}}</pre>-->
  </div>
</template>

<script>
  import chevronRightIcon from '../../../components/Svg/journal/chevronRightIcon'
  import plusIconNoBorder from '../../../components/Svg/journal/plusIconNoBorder'
  import saveIconNoBorder from '../../../components/Svg/journal/saveIconNoBorder'
  import {journalSidebar} from '../../../mixins/journalSidebar'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {toFormData} from "../../../mixins/utils/toFormData";
  import {mapActions, mapState, mapMutations} from "vuex";
  import {showOverlay} from "../../../mixins/utils/showOverlay"
  import trimItem from '../../../components/trimITem'
  import searchIcon from '../../Svg/searchIcon'
  import {delItem} from "../../../mixins/delItem";

  export default {
    name: "journalHeader",
    mixins: [journalSidebar, tokenAndRoute, toFormData, showOverlay, delItem],
    components: { chevronRightIcon, plusIconNoBorder, saveIconNoBorder, trimItem, searchIcon },
    data() {
      return {
        select: '',
        options: ['1',2,3,4,5, 1000, 123123,214125125,152512, 'длинный текст очень очень длинный'],
        select2: '',
        options2: ['1',2,3,4,5, 1000, 123123,214125125,152512, 'длинный текст очень очень длинный'],
        isMenuActive: false,
        isSubmenuActive: false,
        opened: false,
        pressed: false,
        isSavePressed: false,
        // filteredEventTemplatesArray: [],
        date: '',
        bigForm: false,
        delId: '',
        search: '',
      }
    },
    watch: {
      confirm2(val) {
        if (val) {
          this.eventTemplateDelete()
        }
      }
    },
    computed: {
      ...mapState({
        event: state => state.journal.event,
        tempData: state => state.journal.tempData,
        typeCreate: state => state.journal.typeCreate,

        eventType: state => state.journal.eventType,
        eventTemplates: state => state.journal.eventTemplates,

        eventTypes: state => state.journal.eventTypes,

        selectedType: state => state.journal.selectedType,
        selectedDevice: state => state.journal.selectedDevice,

        thing: state => state.things.device,

        user: state => state.auth.user,
        confirm2: state => state.popups.del.confirm2
      }),
      thingPermission() {
        return this.thing.permission_level
      },
      lang() {
        if (localStorage.getItem('lang') === 'ru') {
          return 'ru'
        } else {
          return 'en'
        }
      },
      eventType: {
        get() {
          return this.selectedType
        },
        set(val) {
          this.setSelectedType(val)
        }
      },
      selectDevice: {
        get() {
          return this.selectedDevice
        },
        set(val) {
          this.setSelectedDevice(val)
        }
      },
      eventDevices() {
        let arr = [
          {
            name: 'Все',
            value: ''
          },
          {
            name: this.thing.name,
            value: this.thing.id
          },
        ]
        let deviceFunc = (devices) => {
          devices.forEach((item) => {
            arr.push({name: item.name, value: item.id})
            if (item.devices.length > 0) {
              deviceFunc(item.devices)
            }
          })
        }
        if (this.thing && this.thing.devices.length > 0) {
          this.thing.devices.forEach((item) => {
            arr.push({name: item.name, value: item.id})
            if (item.devices.length > 0) {
              deviceFunc(item.devices)
            }
          })
        }
        return arr
      },
      disableSaveTemplate() {
        return !this.isJournalCreate
      },
      journalView() {
        return this.$route.fullPath.includes('journals/journal-')
      },
      isJournalCreate() {
        return this.$route.name === 'JournalCreate'
      },
    },
    methods: {
      ...mapMutations({
        setEventType: 'journal/SET_EVENT_TYPE',
        resetEvent: 'journal/RESET_EVENT',
        setEvent: 'journal/SET_EVENT',
        setShowAddEventNamePopup: 'journal/SET_SHOW_ADD_EVENT_NAME_POPUP',
        setTempData: 'journal/SET_TEMP_DATA',
        setClearType: 'journal/SET_CLEAR_TYPE',
        setSelectedType: 'journal/SET_SELECTED_TYPE',
        setSelectedDevice: 'journal/SET_SELECTED_DEVICE',
        setTypeCreate: 'journal/SET_TYPE_CREATE',
        setNumberDel: 'popups/del/SET_NUMBER'
      }),
      ...mapActions({
        saveEventTemplate: 'journal/saveEventTemplate',
        getEvents: 'journal/getEvents',
        deleteEventTemplate: 'journal/deleteEventTemplate',
      }),
      searchFunc() {
        let start_date = '';
        let end_date = '';
        if (this.date && this.date[0] !== null) {
          start_date = this.date[0].getTime() / 1000;
          end_date = this.date[1].getTime() / 1000;
        }
        let param = {
          id: this.$route.params.id,
          search: this.search,
          start_date: start_date,
          end_date: end_date,
          event_type: this.eventType.value
        }
        this.getEvents(param);
      },
      dateFunc() {
        let start_date = '';
        let end_date = '';
        if (this.date && this.date[0] !== null) {
          start_date = this.date[0].getTime() / 1000;
          end_date = this.date[1].getTime() / 1000;
        }
        let param = {
          id: this.$route.params.id,
          search: this.search,
          start_date: start_date,
          end_date: end_date,
          event_type: this.eventType.value
        }
        this.getEvents(param);
      },
      typeFunc() {
        let start_date = '';
        let end_date = '';
        if (this.date && this.date[0] !== null) {
          start_date = this.date[0].getTime() / 1000;
          end_date = this.date[1].getTime() / 1000;
        }
        let param = {
          id: this.$route.params.id,
          search: this.search,
          start_date: start_date,
          end_date: end_date,
          event_type: this.eventType.value
        }
        this.getEvents(param);
      },
      eventTemplateRemove(id) {
        this.setNumberDel(2);
        this.showOverlay(true);
        this.showDelPopup(true);
        this.delId = id
      },
      async eventTemplateDelete() {
        this.setNumberDel(1);
        await this.deleteEventTemplate({id: this.delId})
        this.delId = '';
      },
      showBigForm() {
        this.bigForm = true
      },
      hideBigForm() {
        this.bigForm = false
      },
      showMenu() {
        this.isMenuActive = !this.isMenuActive;
        if (this.isMenuActive) {
          this.opened = true;
          this.pressed = true
        } else {
          this.opened = false;
          this.pressed = false
        }
      },
      showSubmenu() {
        this.isSubmenuActive = !this.isSubmenuActive
      },
      hideFirstMenu() {
        if (this.isSubmenuActive) {
          return false
        } else {
          this.isMenuActive = false
        }
      },
      hideAllMenu() {
        //закрыть submenu
        this.isSubmenuActive = false
        this.opened = false
        this.pressed = false
        //а это закроет оба
        this.isMenuActive = false
      },

      async saveEventTemplate() {
        if (this.eventType) {
          this.showOverlay(true);
          this.setShowAddEventNamePopup(true);
          let data = {
            device_id: this.routeId,
            content: JSON.stringify(this.event),
            type: this.typeCreate,
            name: ''
          }
          this.setTempData(data)
        } else {
          this.setClearType(true);
          setTimeout(() => this.setClearType(false), 1500)
        }

        // let formData = this.toFormData(data)
        // await this.saveEventTemplate(formData)
      },
      goToNewEvent() {
        this.resetEvent();
        this.$router.push(`/journals/journal-${this.routeId}/create`);
        this.hideAllMenu()
      },
      chooseEventTemplate(template) {
        let temp = JSON.parse(template.content);
        this.setEvent(temp)
        this.setTypeCreate(template.type)
        this.$router.push({name: 'JournalCreate'});
        this.hideAllMenu()
      },

    }
  }
</script>

<style lang="scss" scoped>
  .journal-header {
    position: fixed;
    padding: 13px 0;
    background-color: #EFF3F6;
    width: calc(100% - (240px + 260px));
    height: 70px;
    border-bottom: 1px solid #D7E3EA;
    z-index: 3;
    right: 0;
    transition: all .25s;

    &.sidebar-small {
      width: calc(100% - 310px);
    }
  }

  .header-content {
    width: 100%;
   // max-width: 800px;
    padding-left: 66px;
    padding-right: 77px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .journal-buttons {
    display: flex;
    align-items: center;
    .journal-btn-plus, .journal-btn-save {
      margin-right: 20px;
      width: 40px;
      height: 40px;
      border: 1px solid #109CF1;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        &:not(:disabled) {
          border: #39B54A;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%), #39B54A;
        }
      }
      &:disabled{
        opacity: .4;
      }
    }
    .journal-btn-plus {
      border: none;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%), #39B54A;
      &:hover {
        &:not(:disabled) {
          filter: drop-shadow(0px 4px 12px rgba(0, 82, 127, 0.2))
        }
      }
    }
    .pressed {
      border: none;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%), #39B54A;
      &:hover {
        border: none;
      }
    }
    .not-editable {
      background: rgba(0, 82, 127, 0.2);
      border: none;
    }
  }

  .journal-btn-plus-wrap {
    position: relative;

    .menu, .submenu {
      z-index: 2;
      display: none;
      position: absolute;
      left: 0;
      top: 50px;
      width: 260px;
      background-color: white;
      border-radius: 8px;
      a:visited {
        color: $darkBlue;
      }
    }
    .submenu-wrap {
      background-color: transparent;
      position: absolute;
      left: -10px;
      width: 550px;
      min-height: 130px;
    }
    .submenu {
      left: 275px;
      top: 10px;
      /*padding-left: 20px;*/
    }
    .opened {
      display: block;
    }
    li {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      padding: 20px;
      font-family: $msb;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      border-bottom: 1px solid rgba(0, 82, 127, 0.1);
      transition: $anim;
      &:last-child {
        border-bottom: none;
      }
    }
    .btn-centered:hover {
      color: $blue;
    }
  }

  .journal-filters {
    position: relative;
    display: flex;
    justify-content: flex-end;
    padding-right: 56px;

    .select-cont {
      width: 220px;
      position: relative;
      &:nth-child(2) {
        margin-right: -1px;
      }
      &:nth-child(3) {
        margin-right: -1px;
      }

      .placeholder {
        position: absolute;
        font-size: 13px;
        top: 14px;
        left: 10px;
        background: #EFF3F6;
      }

      .mx-datepicker {
        width: 100%;
        height: 40px;
        border: 1px solid rgba(0, 82, 127, 0.2);
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
      }
    }

    h2 {
      margin-right: 20px;
      font-family: $mm;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      display: flex;
      align-items: center;
      letter-spacing: 0.25px;
      user-select: none;
    }

    &.disabled {
      opacity: .4;
    }
  }

  .remove-event-template {
    opacity: 0.2;
    transition: $anim;
    z-index: 2;

    &:hover {
      opacity: 0.6;
    }
  }

</style>

<style lang="scss">
  .journal-buttons > .journal-btn-plus-wrap li {
    svg path {
      transition: all .3s;
    }
    &:hover {
      cursor: pointer;
      //color: $blue;
      svg path {
        fill: white;
      }
    }
  }
  .show-small-sidebar {
    .journal-header {
      width: calc(100% - (320px));
      &.sidebar-small {
        width: calc(100% - (130px));
      }
    }
  }
  .journal-buttons .journal-btn-save {
    svg path {
      transition: $anim;
    }
    &:hover {
      &:not(:disabled){
        cursor: pointer;
        svg path {
          fill: white;
        }
      }
    }
  }

  .device-chooser {
    .vs__selected {
      width: calc(100% - 90px) !important;
    }
    .vs__dropdown-toggle {
      padding-left: 60px !important;
    }
  }
  .event-type-chooser {
    .placeholder {

    }

    .vs__selected {
      width: calc(100% - 140px) !important;
    }
    .vs__dropdown-toggle {
      padding-left: 110px !important;
    }
  }
  .search-form {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    border: 1px solid rgba(0, 82, 127, 0.2);
    border-radius: 4px;
    transition: $anim;
    overflow: hidden;

    &:hover {
      input {
        border: 1px solid $lightGrey;
      }
    }

    .search-cont {
      width: 100%;
    }

    svg {
      position: absolute;
      left: 10px;
      top: 10px;
      transition: $anim;
    }

    input {
      width: 100%;
      height: 40px;
      padding: 0 60px;
      font-family: $mm;
      font-size: 14px;
      color: $darkBlue;
      border-radius: 4px;
      border: 0 !important;
      background: transparent;
      outline: none;
      transition: $anim;

      &::placeholder {
        font-family: $mm;
        font-size: 14px;
        color: $darkBlue;
      }

      &:hover, &:focus {
        border: 0 !important;
      }
    }
  }

  .search-from_big {
    width: 100%;

    svg {
      left: 20px;
    }

    input {
      background: #ffffff;
    }
  }
  .journal-filters {

    .select-cont {

      &:nth-child(2) {

        .vs__dropdown-toggle {
          border-bottom-right-radius: 0 !important;
          border-top-right-radius: 0 !important;
        }
      }

      &:nth-child(3) {

        .vs__dropdown-toggle {
          border-radius: 0 !important;
        }
      }

      .mx-datepicker {

        .mx-input-wrapper {
          height: 40px;

          input {
            width: 100%;
            height: 40px;
            padding-left: 60px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
</style>
